import {
    displayCurrency,
    displayShortDateShortYear,
    displayYear
} from '../../utils/Format/Format';

export const HistoricalPricesTableCardUtil = (gqlResult) => {
    if (!gqlResult) return null;
    const {
        price: { asOfDate: ytdAsOf },
        monthlyHighPrice: { price: monthHigh, asOfDate: asOfMHigh },
        monthlyLowPrice: { price: monthLow, asOfDate: asOfMLow },
        ytdLowPrice: { price: yearLow, asOfDate: asOfYLow },
        ytdHighPrice: { price: yearHigh, asOfDate: asOfYHigh },
        annualHistoricalLowPrices,
        annualHistoricalHighPrices
    } = gqlResult.mutualFund;
    const headers = ['Historical Prices', 'High', 'Low'];
    const pastThreeYears = annualHistoricalHighPrices
        .filter((_, i) => i < 3)
        .map((ele, i) => ({
            label: displayYear(ele.asOfDate),
            values: [
                {
                    data: {
                        price: displayCurrency(ele.price),
                        date: displayShortDateShortYear(ele.asOfDate)
                    }
                },
                {
                    data: {
                        price: displayCurrency(
                            annualHistoricalLowPrices[i].price
                        ),
                        date: displayShortDateShortYear(
                            annualHistoricalLowPrices[i].asOfDate
                        )
                    }
                }
            ]
        }));
    const data = [
        {
            label: {
                label: 'Prior Month'
            },
            values: [
                {
                    data: {
                        price: displayCurrency(monthHigh),
                        date: displayShortDateShortYear(asOfMHigh)
                    }
                },
                {
                    data: {
                        price: displayCurrency(monthLow),
                        date: displayShortDateShortYear(asOfMLow)
                    }
                }
            ]
        },
        {
            label: { label: 'YTD', date: displayShortDateShortYear(ytdAsOf) },
            values: [
                {
                    data: {
                        price: displayCurrency(yearHigh),
                        date: displayShortDateShortYear(asOfYHigh)
                    }
                },
                {
                    data: {
                        price: displayCurrency(yearLow),
                        date: displayShortDateShortYear(asOfYLow)
                    }
                }
            ]
        },
        ...pastThreeYears
    ];

    return {
        data,
        headers,
        title: 'Historical Prices'
    };
};
